import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32659eaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backtest-period" }
const _hoisted_2 = { class: "tag-group" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "tag-remove"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 自定义")
const _hoisted_6 = {
  key: 0,
  class: "tag-remove"
}
const _hoisted_7 = { class: "date-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "date-arrow" }, "→", -1))
const _hoisted_9 = { class: "date-text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "date-icon-inline",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "1",
    y: "3",
    width: "14",
    height: "12",
    rx: "2",
    stroke: "#e8392a",
    "stroke-width": "1.5"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 7h14",
    stroke: "#e8392a",
    "stroke-width": "1.5"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 1v4M11 1v4",
    stroke: "#e8392a",
    "stroke-width": "1.5",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_11 = { class: "cal-header" }
const _hoisted_12 = { class: "cal-title" }
const _hoisted_13 = { class: "cal-weekdays" }
const _hoisted_14 = { class: "cal-days" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "cal-footer" }
const _hoisted_17 = { class: "cal-hint" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodOptions, (opt) => {
        return (_openBlock(), _createElementBlock("div", {
          key: opt.value,
          class: _normalizeClass(["tag-item", { selected: _ctx.period === opt.value }]),
          style: _normalizeStyle(_ctx.tagStyle(_ctx.period === opt.value)),
          onClick: ($event: any) => (_ctx.selectPeriod(opt.value))
        }, [
          _createTextVNode(_toDisplayString(opt.label) + " ", 1),
          (_ctx.period === opt.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "×"))
            : _createCommentVNode("", true)
        ], 14, _hoisted_3))
      }), 128)),
      _createElementVNode("div", {
        class: _normalizeClass(["tag-item", { selected: _ctx.period === 'custom' }]),
        style: _normalizeStyle(_ctx.tagStyle(_ctx.period === 'custom')),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectPeriod('custom')))
      }, [
        _hoisted_5,
        (_ctx.period === 'custom')
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "×"))
          : _createCommentVNode("", true)
      ], 6),
      (_ctx.period === 'custom')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "date-range-tag",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args)))
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.startDate || 'yyyy/mm/dd'), 1),
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.endDate || 'yyyy/mm/dd'), 1),
            _hoisted_10,
            _createElementVNode("span", {
              class: "tag-remove",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectPeriod('3m')), ["stop"]))
            }, "×")
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showCalendar)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "cal-mask",
            onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeCalendar && _ctx.closeCalendar(...args)), ["self"]))
          }, [
            _createElementVNode("div", {
              class: "cal-popup",
              style: _normalizeStyle(_ctx.calPopupStyle),
              onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "cal-nav",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.prevMonth && _ctx.prevMonth(...args)))
                }, "‹"),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.calYear) + "年" + _toDisplayString(_ctx.calMonth + 1) + "月", 1),
                _createElementVNode("button", {
                  class: "cal-nav",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args)))
                }, "›")
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['一','二','三','四','五','六','日'], (d) => {
                  return _createElementVNode("span", { key: d }, _toDisplayString(d), 1)
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calCells, (cell, i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: i,
                    class: _normalizeClass(["cal-cell", _ctx.getCellClass(cell)]),
                    onClick: ($event: any) => (cell.date && _ctx.onCellClick(cell.date))
                  }, _toDisplayString(cell.day), 11, _hoisted_15))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.pickStep === 'start' ? '请选择开始日期' : '请选择结束日期'), 1),
                _createElementVNode("button", {
                  class: "cal-clear",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearDates && _ctx.clearDates(...args)))
                }, "清除"),
                _createElementVNode("button", {
                  class: "cal-confirm",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.confirmDates && _ctx.confirmDates(...args))),
                  disabled: !_ctx.tempStart || !_ctx.tempEnd
                }, "确定", 8, _hoisted_18)
              ])
            ], 4)
          ]))
        : _createCommentVNode("", true)
    ]))
  ]))
}